/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { http, HttpResponse } from 'msw';
import knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations from './mockdata/knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations.json';
import knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_cube_ta_20250520_0500 from './mockdata/knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_cube_ta_20250520_0500.json';
import knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_locations from './mockdata/knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_locations.json';
import knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_update from './mockdata/knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_update.json';

export const fakeEdrLayerApiHandlers = [
  http.get(
    'https://gw-edr.pub.knmi.cloud/edr/collections/10-minute-in-situ-meteorological-observations',
    () => {
      return HttpResponse.json(
        knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations,
      );
    },
  ),
  http.get(
    'https://gw-edr.pub.knmi.cloud/edr/collections/10-minute-in-situ-meteorological-observations-update',
    () => {
      return HttpResponse.json(
        knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_update,
      );
    },
  ),
  http.get(
    'https://gw-edr.pub.knmi.cloud/edr/collections/10-minute-in-situ-meteorological-observations/locations',
    () => {
      return HttpResponse.json(
        knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_locations,
      );
    },
  ),
  http.get(
    'https://gw-edr.pub.knmi.cloud/edr/collections/10-minute-in-situ-meteorological-observations/cube',
    ({ request }) => {
      const url = new URL(request.url);
      const parameterName = url.searchParams.get('parameter-name');
      const dateTime = url.searchParams.get('datetime');
      const bbox = url.searchParams.get('bbox');
      if (
        parameterName === 'ta' &&
        dateTime === '2025-05-20T05:00:00Z' &&
        bbox === '-180,-90,180,90'
      ) {
        return HttpResponse.json(
          knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_cube_ta_20250520_0500,
        );
      }
      return HttpResponse.json(
        {
          error: `Parameter not found (got: [${parameterName}]/[${dateTime}]/[${bbox}]`,
        },
        { status: 404 },
      );
    },
  ),
  http.get(
    'https://gw-edr.pub.knmi.cloud/edr/collections/10-minute-in-situ-meteorological-observations-update/cube',
    ({ request }) => {
      const url = new URL(request.url);
      const parameterName = url.searchParams.get('parameter-name');
      const dateTime = url.searchParams.get('datetime');
      const bbox = url.searchParams.get('bbox');
      if (
        parameterName === 'ta' &&
        dateTime === '2025-05-20T05:00:00Z' &&
        bbox === '-180,-90,180,90'
      ) {
        return HttpResponse.json(
          knmi_kdp_edr_collections_10_minute_in_situ_meteorological_observations_cube_ta_20250520_0500,
        );
      }
      return HttpResponse.json(
        {
          error: `Parameter not found (got: [${parameterName}]/[${dateTime}]/[${bbox}]`,
        },
        { status: 404 },
      );
    },
  ),
];
